import React, { useEffect, useMemo } from "react";
import "./OrderSalesReport.css";
import OrderReportHeader from "./OrderReportHeader/OrderReportHeader";
import OrderReportFooter from "./OrderReportFooter/OrderReportFooter";
import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { getPickTicketColumn, getNewPTReport } from "../../redux/actions/pickTicketReport.action"
import { useLocation } from "react-router-dom";
import { currencySymbol } from "../../utils/constants";
import { Button, Spin } from "antd";

const NewOrderReport = () => {
  const dispatch = useDispatch();
  const token = ReadCookie("token");
  const {
    PickTicketColumn,
    newPTReport
  } = useSelector((state) => state);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  let ship_header_id = query.get("ship_header_id")

  useEffect(() => {
    dispatch(getPickTicketColumn(token, values));
    dispatch(getNewPTReport(token, values));
  }, []);

  const footerData =
    newPTReport && newPTReport?.payload?.data[0];
  let groupValues =
    newPTReport &&
    newPTReport?.payload?.data.reduce(function (r, a) {
      r[a.gender_category_id] = r[a.gender_category_id] || [];
      r[a.gender_category_id].push(a);
      return r;
    }, Object.create(null));
  const groupedColumnValue = groupValues && Object.values(groupValues);

  const values = {
    ship_header_id: ship_header_id,
  };

  const myData = useMemo(() => {
    return PickTicketColumn?.payload?.data.map((it, i) => {
      return {
        column: it,
        detail: groupedColumnValue && groupedColumnValue[i],
      };
    });
  }, [groupedColumnValue, PickTicketColumn]);

  const handlePrint = () => {
    const css = '@page { size: portrait;}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };


  if (!(myData || []).length) {
    return <div className="spin">
      <Spin size="large" />
    </div>
  }

  return (
    <div className="__sale_order_pt_report">
      <table width="100%">
        <thead>
          <tr>
            <td>
              <OrderReportHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={myData} footerData={footerData} />
              <div className="__footer_placeholder"></div>
              <OrderReportFooter />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default NewOrderReport;

const Body = ({ myData, footerData }) => {
  return (
    <div className="__content">
      <div className="__list_items">
        {myData?.map((size, index) => {
          return (
            <table key={index} width="100%">
              <tbody>
                <tr>
                  <th
                    style={{
                      width: "36px",
                    }}
                  >
                    S.No
                  </th>
                  <th
                    style={{
                      width: "88px",
                    }}
                  >
                    SKU #
                  </th>
                  <th
                    style={{
                      width: "80px",
                    }}
                  >
                    Brand
                  </th>
                  <th
                    style={{
                      width: "240px",
                    }}
                  >
                    Style/Desc
                    <span style={{ marginLeft: "5px" }}>
                      {size?.column?.gender_category_name}
                    </span>
                  </th>
                  <th
                    className="__size_col"
                  >
                    {size.column.hq23 && size.column.hq23}
                  </th>
                  <th className="__size_col">
                    {size.column.hq24 && size.column.hq24}
                  </th>
                  <th className="__size_col">
                    {size.column.hq25 && size.column.hq25}
                  </th>
                  <th className="__size_col">
                    {size.column.hq26 && size.column.hq26}
                  </th>
                  <th className="__size_col">
                    {size.column.hq27 && size.column.hq27}
                  </th>
                  <th className="__size_col">
                    {size.column.hq28 && size.column.hq28}
                  </th>
                  <th className="__size_col">
                    {size.column.hq29 && size.column.hq29}
                  </th>
                  <th className="__size_col">
                    {size.column.hq30 && size.column.hq30}
                  </th>
                  <th className="__size_col">
                    {size.column.hq31 && size.column.hq31}
                  </th>
                  <th className="__size_col">
                    {size.column.hq32 && size.column.hq32}
                  </th>
                  <th className="__size_col">
                    {size.column.hq33 && size.column.hq33}
                  </th>
                  <th className="__size_col">
                    {size.column.hq34 && size.column.hq34}
                  </th>
                  <th className="__size_col">
                    {size.column.hq35 && size.column.hq35}
                  </th>
                  <th className="__size_col">
                    {size.column.hq36 && size.column.hq36}
                  </th>
                  <th className="__size_col">
                    {size.column.hq37 && size.column.hq37}
                  </th>
                  <th className="__size_col">
                    {size.column.hq38 && size.column.hq38}
                  </th>
                  <th
                    style={{
                      width: "50px",
                    }}
                  >
                    Quantity
                  </th>
                  <th
                    style={{
                      width: "90px",
                    }}
                  >
                    Rate
                  </th>
                  <th
                    style={{
                      width: "90px",
                    }}
                  >
                    Amount
                  </th>
                </tr>
                {size.detail?.map((it, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td
                        style={{
                          marginLeft: "0",
                        }}
                      >
                        {it.item_code}
                      </td>
                      <td>
                        {it?.brand_name}
                      </td>
                      <td>
                        {it.description}
                      </td>
                      <td className="__size_col">
                        {it.qty_1 && Number(it.qty_1).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_2 && Number(it.qty_2).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_3 && Number(it.qty_3).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_4 && Number(it.qty_4).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_5 && Number(it.qty_5).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_6 && Number(it.qty_6).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_7 && Number(it.qty_7).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_8 && Number(it.qty_8).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_9 && Number(it.qty_9).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_10 && Number(it.qty_10).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_11 && Number(it.qty_11).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_12 && Number(it.qty_12).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_13 && Number(it.qty_13).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_14 && Number(it.qty_14).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_15 && Number(it.qty_15).toFixed(0)}
                      </td>
                      <td className="__size_col">
                        {it.qty_16 && Number(it.qty_16).toFixed(0)}
                      </td>
                      <td>
                        {it.quantity && Number(it.quantity).toFixed(0)}
                      </td>
                      <td>{currencySymbol} {it.rate && it.rate}</td>
                      <td>{currencySymbol} {it.amount && Number(it.amount).toFixed(2)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        })}
      </div>
      <div className="__summary_box">
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td width="250px">
                <table width="100%" className="__summary_box_table">
                  <tbody>
                    <tr>
                      <td width="70%" align="right">Total Quantity</td>
                      <td width="30%">{footerData?.gross_quantity}</td>
                    </tr>
                    <tr>
                      <td colSpan={2} style={{ border: 0, height: '15px' }}></td>
                    </tr>
                    <tr>
                      <td colSpan={2} align="center">
                        {footerData && footerData.term} ORDER
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        Amount
                      </td>
                      <td>
                        {currencySymbol} {footerData && Number(footerData.sum_gross_amount).toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td align="right">
                        Discount Amount
                      </td>
                      <td>{currencySymbol} {footerData && Number(footerData.discount).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="right">
                        Surcharge Amount
                      </td>
                      <td>{currencySymbol} {footerData && Number(footerData.surcharge_amount || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="right">
                        Tax Amount
                      </td>
                      <td>{currencySymbol} {footerData && Number(footerData.tax_amount || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="right">
                        Freight Amount
                      </td>
                      <td>{currencySymbol} {footerData && Number(footerData.freight_amount).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td align="right">
                        Net Amount
                      </td>
                      <td>{currencySymbol} {footerData && Number(footerData.net_amount).toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
